/**
 * Group Leaderboard Screen Styles
 * Composed from sub-files via the combine pattern.
 */

import { StyleSheet, type ViewStyle } from 'react-native'
import type { Theme } from '../src/theme/getTheme'
import { getGroupLeaderboardHeroStyleSheet } from './_groupLeaderboardHero.styles'
import { getGroupLeaderboardTableStyleSheet } from './_groupLeaderboardTable.styles'
import { getGroupLeaderboardSectionsStyleSheet } from './_groupLeaderboardSections.styles'

const AVATAR_SIZE = 56

/** Returns positioning style for the row menu dropdown (below the 3-dot trigger). */
export const getRowMenuDropdownPosition = (top: number, right: number) => ({
  position: 'absolute' as const,
  top,
  right,
})

/** marginLeft for icon so it sits just right of the centered name. */
export const getGroupTitleIconMarginLeft = (titleBlockWidth: number): ViewStyle => ({
  marginLeft: (titleBlockWidth > 0 ? titleBlockWidth / 2 : 24) + 8,
})

export const getGroupLeaderboardStyles = (theme: Theme) => {
  const combined = {
    ...getGroupLeaderboardHeroStyleSheet(theme),
    ...getGroupLeaderboardTableStyleSheet(theme),
    ...getGroupLeaderboardSectionsStyleSheet(theme),
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return StyleSheet.create(combined as any)
}

export const GROUP_LEADERBOARD_AVATAR_SIZE = AVATAR_SIZE
/** Rank crest on a row avatar — the design's ~0.55 crest-to-avatar ratio at this scale. */
export const GROUP_LEADERBOARD_CREST_SIZE = 30
export const TABLE_HEADER_ICON_SIZE = 18
